// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3d-bK","rootSuccess":"CompleteLink_rootSuccess__2tIBq","rootFailure":"CompleteLink_rootFailure__2zWXH","isDisabled":"CompleteLink_isDisabled__18XZn"};